export function ProjectSwitcher({ projects, slot, onChange }) {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3" data-testid="project-switcher">
      {projects.map((p) => {
        const active = p.slot === slot;
        return (
          <button key={p.slot} onClick={() => onChange(p.slot)} data-testid={`project-slot-tab-${p.slot}`}
            className={`lift text-left rounded-xl border p-4 ${active ? "border-primary bg-primary/10" : "border-border bg-card hover:bg-secondary/60"}`}>
            <div className="flex items-center justify-between">
              <span className={`text-[11px] font-mono uppercase tracking-wider ${active ? "text-primary" : "text-muted-foreground"}`}>P{p.slot}</span>
              {p.stats.running > 0 && <span className="h-2 w-2 rounded-full bg-amber-500 animate-pulse" title="Campaign running" />}
            </div>
            <p className="font-display font-semibold mt-1 truncate">{p.name}</p>
            <p className="text-xs text-muted-foreground font-mono mt-0.5">{p.stats.total_leads} leads</p>
          </button>
        );
      })}
    </div>
  );
}
